<template>
  <div class="user-profile-page">
    <b-card no-body class="p-0 m-0 banner-card">
      <b-card-body class="m-0 p-0">
        <div class="top-banner">
          <div class="bg-filter"></div>
          <div class="avatar-image"></div>
        </div>

        <div class="profile-highlight">
          <div class="hightlight-button">
            <!-- Change Password btn -->
            <!-- <b-button variant="warning-light">
              <i class="ri-key-2-line"></i>
              <span>Change Password</span>
            </b-button> -->
            <!-- Logout -->
            <b-button variant="danger-light" @click="logOut">
              <i class="ri-logout-circle-r-line"></i>
              <span>Log Out</span>
            </b-button>
          </div>
          <h4 v-if="data">{{ data.customer_name || data.name }}</h4>
          <p v-if="data">Joined {{ formatDate(data.created_at) }}</p>

          <div class="highlight-list" v-if="false">
            <div
              class="highlight-item"
              v-for="(item, i) in highlight"
              :key="'highlight' + i"
            >
              <div class="highlight-content-wrapper">
                <div class="icon-wrapper">
                  <i
                    :class="{
                      [`ri-${item.icon}`]: true,
                    }"
                  ></i>
                </div>

                <div class="hightlight-text centerize-col">
                  <h4>{{ item.label }}</h4>
                  <p class="highlight-value">
                    {{ item.value | parse("thousandSep") }}
                  </p>
                </div>
              </div>

              <i class="ri-arrow-right-s-line chevron-icon"></i>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <div class="profile-project" v-if="false">
      <b-card no-body class="profile-info">
        <b-card-header>
          <h4 class="mb-0 pb-0">Personal Information</h4>
        </b-card-header>
        <b-card-body class="pt-4">
          <div class="profile-info-list">
            <div
              class="profile-info-item"
              v-for="(item, i) in profileInfo"
              :key="'profile-info-' + i"
            >
              <i
                :class="{
                  [`ri-${item.icon}`]: true,
                }"
                v-b-tooltip.hover
                :title="item.label"
              ></i>
              <span class="profile-info-value">
                <span v-if="!data">-</span>
                <span v-else>
                  <span v-if="!item.type && data[item.key]">{{
                    data[item.key]
                  }}</span>
                  <b-badge
                    :variant="item.variant"
                    v-else-if="
                      item.type && data[item.key] && item.type == 'badge'
                    "
                  >
                    {{ data[item.key] }}
                  </b-badge>
                  <span v-else-if="item.type === 'date' && data[item.key]">{{
                    data[item.key] | parse("date")
                  }}</span>
                  <div
                    v-else-if="
                      item.type === 'custom' &&
                      item.key == 'corporate' &&
                      data.corporate_id
                    "
                  >
                    <div v-if="data.corporate_id">
                      {{ data.corporate_name }}
                    </div>
                  </div>
                  <span v-else>-</span>
                </span>
              </span>
            </div>
          </div>

          <b-button
            variant="warning-light centerize-row w-100 mt-3 justify-content-center"
          >
            <i class="ri-edit-box-line"></i>
            <span>Edit Profile</span>
          </b-button>
        </b-card-body>
      </b-card>
      <b-card no-body class="project-info">
        <b-card-header>
          <h4 class="mb-0 pb-0">Current Projects</h4>
        </b-card-header>

        <b-card-body>
          <div class="project-info-list">
            <div
              class="project-info-item"
              v-for="(item, i) in projects"
              :key="'project-list-' + i"
            >
              <div class="centerize-row justify-content-between">
                <b-badge variant="light">{{ item.code }}</b-badge>
                <b-badge variant="success">{{
                  item.project_type_name
                }}</b-badge>
              </div>

              <div class="total-tree">
                <span class="value">{{ 1000 | parse("thousandSep") }}</span>
                <span class="label font-weight-300">pohon</span>
              </div>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>

    <Maintenance />
  </div>
</template>

<script>
import Maintenance from "../../default-page/maintenance.vue";
import "./profile.scss";
import moment from "moment";

export default {
  name: "profile-user",

  components: {
    Maintenance,
  },

  data() {
    return {
      fetch: 0,
      data: null,
      formatDate: (date, format = "DD MMM YYYY HH:mm") => {
        return moment(date).format(format);
      },
      highlight: [
        {
          label: "Project",
          icon: "file-edit-fill",
          value: 3,
          path: "/orders/project",
        },
        {
          label: "Tree Planted",
          icon: "tree-fill",
          value: 1000000,
          path: "/maindata/land",
        },
        {
          label: "Planting",
          icon: "plant-line",
          value: 10,
          path: "/maindata/land",
        },
        {
          label: "Event",
          icon: "calendar-event-line",
          value: 4,
          path: "/orders/event",
        },
      ],
      projects: [],

      profileInfo: [
        {
          label: "Username",
          icon: "at-line",
          key: "username",
        },
        {
          label: "No HP",
          icon: "phone-fill",
          key: "phone",
        },
        {
          label: "Email",
          icon: "mail-fill",
          key: "email",
        },
        {
          label: "DOB",
          icon: "calendar-line",
          key: "customer_dob",
        },
        {
          label: "Role",
          icon: "user-3-fill",
          key: "role_name",
          type: "badge",
          variant: "info-light",
        },
        {
          label: "Tgl. Bergabung",
          icon: "group-fill",
          type: "date",
          key: "created_at",
        },
        {
          label: "Perusahaan",
          icon: "building-4-fill",
          key: "corporate",
          type: "custom",
        },
      ],
    };
  },

  mounted() {
    // this.getData();
  },

  methods: {
    getData() {
      const userProfilePromise = this.$_api.get("users/profile");
      const projectListPromise = this.$_api.get("project/list");

      Promise.all([userProfilePromise, projectListPromise])
        .then(([user, project]) => {
          console.log("user", user, project);
          this.data = user.profile;
          this.projects = project.data;
          this.fetch = 1;
        })
        .catch((err) => {
          this.fetch = 2;
          this.$_alert.error(err);
        });
    },

    logOut() {
      localStorage.clear();
      this.$router.push({ path: "/login" });
      this.$store.replaceState({
        sideNavPrimary: false,
        sideNavSecondary: false,
        sideNavMobile: false,
      });
      this.$_sys.togleClass("kt_body", "aside-minimize", true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/modules/profile/profile.vue